export default __webpack_public_path__ + "common/images/newscorpaus-logo-white.svg";